<template>
  <div>
    <div v-for="item in data" :key="item[itemName]">
      <div class="pl-1 pr-1 pt-3 pb-3 primary d-flex">
        <v-flex xs6 sm5><span>{{ item[itemName] }}</span></v-flex>
        <v-flex sm1><span>:</span></v-flex>
        <v-flex xs6>
          <div :class="item[itemValue] == 'NO DATA' || item[itemValue] == '-' ? 'error--text no-value' : 'number--text value'"> {{ $t(item[itemValue]) }} </div>
        </v-flex>
      </div>
      <v-divider class="custom-divider" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    itemName: {
      type: String,
      default: 'name'
    },
    itemValue: {
      type: String,
      default: 'value'
    }
  }
}
</script>

<style scoped>
.custom-divider {
  background-color: #334079;
}

.no-value {
  font-size: 14px;
  font-weight: 500;
}

.value {
  font-size: 14px;
  font-weight: 500;
}
</style>
